function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 9C5 6.79086 6.79086 5 9 5H15V15H5V9Z",
  fill: "#D5D7DE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 17H15V27H9C6.79086 27 5 25.2091 5 23V17Z",
  fill: "#EC7963"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 5H23C25.2091 5 27 6.79086 27 9V15H17V5Z",
  fill: "#D5D7DE"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 17H27V23C27 25.2091 25.2091 27 23 27H17V17Z",
  fill: "#D5D7DE"
});

var SvgFourZoomInLeftBottom = function SvgFourZoomInLeftBottom(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFourZoomInLeftBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fourZoomInLeftBottom.24d95f38.svg";
export { ForwardRef as ReactComponent };